<template>
  <div class="safety">
    <div class="safety-content">
      <div class="safety-content-head">
        <div>希望助学</div>
        <div><img src="@/assets/line.png" alt="" /></div>
        <div>HOPE ALL THE STUDENT</div>
      </div>
      <div class="safety-content-main">
        <div
          class="main-item"
          v-for="(v, i) in navList"
          :key="i"
          @mouseout="hoverOut()"
          @mouseover="hoverShow(i)"
          @click="goDetail(v)"
        >
          <div><img :src="FILE_BASE_URL + v.image" /></div>
          <div>
            <div>{{ v.title }}</div>
            <div>{{ v.introduce }}</div>
            <div v-if="current == i">
              <span style="color: #c1141e">查看详情</span>
              <img src="@/assets/gengduohongse.png" alt="" />
            </div>
            <div v-else>
              <span>查看详情</span>
              <img src="@/assets/gengduoicon.png" alt="" />
            </div>
          </div>
        </div>
        <div style="text-align: center">
          <a-pagination
            :pageSize="pageSize"
            v-model="current"
            :total="total"
            @change="changePage"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      current: 1,
      pageInfo: {},
      navList: [],
      pageSize: 10,
      total: "",
      FILE_BASE_URL: this.$API.FILE_BASE_URL,
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    hoverShow(i) {
      this.current = i;
    },
    hoverOut() {
      this.current = -1;
    },
    goDetail(item) {
      // 详情数据存本地存储，详情页直接本地存储获取
      localStorage.setItem("info", JSON.stringify(item));

      this.$router.push({
        path: "/projects/detail?index=2&title=机构项目&curIndex=1&type=5",
      });
    },
    /**初试加载数据*/
    load(page = 1) {
      let params = {
        type: 1,
        pageNo: page,
        pageSize: this.pageSize,
      };
      this.$API.getFundAgencyManagementlist(params).then((res) => {
        this.navList = res.result.records;
        this.pageSize = res.result.size;
        this.total = res.result.total;
        this.pagiCur = res.result.pages;
        console.log("this.navList" + this.navList);
      });
    },
    // 改变页码
    changePage(page) {
      this.load(page);
    },
  },
};
</script>
<style scoped lang="scss">
.safety {
  width: 100%;
}
.safety-content {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 0 60px 0;
}
.safety-content-head {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  > div:nth-child(1) {
    font-size: 26px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #333333;
  }
  > div:nth-child(2) {
    margin-top: 12px;
  }
  > div:nth-child(3) {
    font-size: 12px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
    font-weight: 400;
    color: #999999;
    margin-top: 14px;
  }
}
.safety-content-main {
  width: 100%;
  margin-top: 40px;
  > div:not(:first-child) {
    margin-top: 30px;
  }
  .main-item {
    display: flex;

    > div:nth-child(1) {
      img {
        width: 370px;
        height: 208px;
      }
    }
    > div:nth-child(2) {
      width: 100%;
      border: 1px solid #e4e4e4;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // box-shadow: 0px 2px 20px 0px rgba(0,0,0,0.08);
      &:hover {
        box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.08);
      }
      > div:nth-child(1) {
        font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
        font-weight: 700;
        color: #333333;
      }
      > div:nth-child(2) {
        font-size: 15px;
        font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
        font-weight: 400;
        color: #777777;
        margin-top: -30px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      > div:nth-child(3) {
        align-self: flex-end;

        > span {
          font-size: 13px;
          font-family: MicrosoftYaHei, MicrosoftYaHei-Regular;
          font-weight: 400;
          color: #999999;
          vertical-align: bottom;
        }
        img {
          width: 14px;
          height: 14px;
          margin-left: 4px;
          margin-bottom: 2px;
        }
      }
    }
  }
}
.monthly-content-foot {
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
::v-deep .ant-pagination-item-active a {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item-active {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item-active:focus,
.ant-pagination-item-active:hover {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item:focus,
.ant-pagination-item:hover {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item:hover {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-item a:hover {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-prev:hover a {
  color: #c8000e;
  border-color: #c8000e;
}
::v-deep .ant-pagination-next:hover a {
  color: #c8000e;
  border-color: #c8000e;
}
</style>
